import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { debounce } from 'throttle-debounce'
import Router from 'next/router'
import { Preloader } from 'SRC/ui/Preloader'
import { profileMenu } from 'SRC/modules/users/Profile/constants'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { getUserInfo } from 'SRC/modules/users/Profile/selectors'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { RegistrationApi } from 'SRC/modules/users/Registration/api'
import { getPhotos } from 'SRC/modules/ads/shared/selectors'
import { getActiveTab, getWasSentSms } from 'SRC/modules/ads/add/selectors'
import { createAd, setError, setSmsWasSent } from 'SRC/modules/ads/add/actions'
import { prepareFields } from 'SRC/modules/ads/add/functions'
import config from 'SRC/config/config.json'
import useTranslation from 'next-translate/useTranslation'
import { BasicForm } from '../BasicForm'
import { DetailForm } from '../DetailForm'

const AddAdForm = ({
  category,
  hasPriceFromAddon,
  hasPriceFromToAddon,
  hasPriceOnRequestAddon,
  hasAdTitleAddon,
  hasSeperateRangeAddon,
  photos,
  activeTab,
  isAuthorized,
  smsWasSent,
  setSmsWasSent,
  setError,
  createAd
}) => {
  const { t } = useTranslation('common')

  const [formStyle, setFormStyle] = useState('basic')

  const getSendSmsPromise = phone => () => new Promise(async (resolve, reject) => {
    const regApi = new RegistrationApi()
    const smsResponse = await regApi.sendSmsCode(phone, true)
    if (smsResponse.error) return reject('Greška! Kod nije poslat.')

    return resolve(smsResponse)
  })

  const handleSubmit = debounce(500, async (values, actions) => {
    console.log('values', values)
    console.log('actions', actions)

    actions.setSubmitting(true)
    setError('')

    if (!isAuthorized && !smsWasSent && activeTab === 'register')  {
      const { newUser } = values
  
      const phone = `${newUser.dial}${newUser.phone}`.replace('+', '').replace(/ /g, '').trim()
  
      // Send sms...
      const sendSmsPromise = getSendSmsPromise(phone)

      return sendSmsPromise()
        .then(smsResponse => {
          console.log('smsResponse', smsResponse)
          const { statusCode } = smsResponse
  
          if (typeof statusCode !== 'undefined' && (statusCode === 0 || statusCode === 2)) {
            setSmsWasSent(true)
            actions.setSubmitting(false)
            return true
          }
  
          actions.setSubmitting(false)
          return false
        })
        .catch(err => {
          console.log('smserrResponse', err)
          setError(err)
          actions.setSubmitting(false)
          return false
        })
    }
  
    if (Array.isArray(photos)) {
      if (!photos.length) {
        setError(t('addAdNoMedia'))
        // setError(config.adForm.addAdForm.errors.NO_MEDIA)
        actions.setSubmitting(false)
        return false
      }
    }

    const cookies = new CookiesHelper()
    const userId = cookies.get('userId')
    const token = cookies.get('token')
  
    let photosCountOk = false
  
    if (isAuthorized && userId && token) {
      photosCountOk = true
    }
  
    if (Number(values.priceTypeForAddons) === config.adForm.adPriceTypes.fromTo.id && !hasSeperateRangeAddon &&
      (!values.priceFrom || Number(values.priceFrom) === -1 || !values.priceTo || Number(values.priceTo) === -1))
    {
      setError(t("Morate popuniti sva polja!"))
      actions.setSubmitting(false)
      return false
    }
  
    if (!isAuthorized && photos.length > config.adForm.addAdForm.photosLimit) {
      // setError(config.adForm.addAdForm.errors.MEDIA_LIMIT)
      setError(t('addAdMediaLimit'))
      return false
    }

    photosCountOk = true
  
    if (photosCountOk) {
      const options = {
        authInfo: { userId, token },
        photos,
        categoryId: category && category.id,
        activeTab
      }

      const preparedFields = prepareFields(values, options)

      const createAdResult = await createAd(preparedFields)

      if (createAdResult) {
        const href = {
          pathname: `/profile`,
          query: {
            page: profileMenu.ads.code,
            status: 'Unpublished'
          }
        }

        const as = `/profil/${profileMenu.ads.code}?status=Unpublished`

        return Router.push(href, as)
      }

      actions.setSubmitting(false)
    }
  })

  const formProps = {
    hasPriceFromToAddon,
    hasPriceOnRequestAddon,
    hasAdTitleAddon,
    hasSeperateRangeAddon,
    hasPriceFromAddon,
    selectedFormStyle: formStyle,
    setFormStyle,
    onSubmit: handleSubmit
  }

  if (!category) return <Preloader />

  if (!category.hasShortForm) return (
    <React.Fragment>
      <section className='dodaj-oglas-content-category'>
        <span className='selectedCategory'>
          {category ? category.title : t('Sve kategorije')}
        </span>

        <Link href='addAd' as='/dodaj'>
          <a><p>{t('Promijeni kategoriju')}</p></a>
        </Link>
      </section>

      <DetailForm {...formProps} />
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <section className='dodaj-oglas-content-category'>
        <span className='selectedCategory'>
          {category ? category.title : t('Sve kategorije')}
        </span>

        <Link href='addAd' as='/dodaj'>
          <a><p>{t('Promijeni kategoriju')}</p></a>
        </Link>
      </section>

      <div className='choose-form-style'>
        <div
          className={`choose-form-style-item ${formStyle === 'basic' ? 'active' : ''}`}
          onClick={() => setFormStyle('basic')}
        >
          <input id='formStyleBasic' type='radio' name='formStyle' checked={formStyle === 'basic'} />
          <label htmlFor='formStyleBasic' />
          <h4>{t('Osnovna Forma')}</h4> - {t('Kraći formular oglasa')}
        </div>

        <div
          className={`choose-form-style-item ${formStyle === 'detail' ? 'active' : ''}`}
          onClick={() => setFormStyle('detail')}
        >
          <input id='formStyleDetail' type='radio' name='formStyle' checked={formStyle === 'detail'} />
          <label htmlFor='formStyleDetail' />
          <h4>{t('Detaljna Forma')}</h4> - {t('Duži formular oglasa')}
        </div>
      </div>

      {formStyle === 'basic' ? <BasicForm {...formProps} /> : <DetailForm {...formProps} />}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const user = getUserInfo(state)
  const isAuthorized = getIsAuthorized(state)

  let hasPriceFromToAddon = false
  let hasSeperateRangeAddon = false
  let hasPriceFromAddon = false
  let hasPriceOnRequestAddon = false
  let hasAdTitleAddon = false

  if (isAuthorized && user && Array.isArray(user.activeAddons) && user.activeAddons.length) {
    if (user.activeAddons.find(addon => addon.name === 'Cijena OD - DO')) {
      hasPriceFromToAddon = true
    }
    if (user.activeAddons.find(addon => addon.action.label === 'priceRangeSeparate')) {
      hasSeperateRangeAddon = true
    }
    if (user.activeAddons.find(addon => addon.action && addon.action.label === 'priceFrom')) {
      hasPriceFromAddon = true
    }
    if (user.activeAddons.find(addon => addon.name === 'Cijena na upit')) {
      hasPriceOnRequestAddon = true
    }
    if (user.activeAddons.find(addon => addon.name === 'Naslov oglasa')) {
      hasAdTitleAddon = true
    }
  }

  return {
    category: getCurrentSubCategory(state),
    hasPriceFromToAddon,
    hasSeperateRangeAddon,
    hasPriceFromAddon,
    hasPriceOnRequestAddon,
    hasAdTitleAddon,
    isAuthorized,
    activeTab: getActiveTab(state),
    photos: getPhotos(state),
    smsWasSent: getWasSentSms(state)
  }
}

AddAdForm.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number,
    seo: PropTypes.string,
    hasShortForm: PropTypes.bool
  }).isRequired,
  hasPriceFromToAddon: PropTypes.bool.isRequired,
  hasPriceOnRequestAddon: PropTypes.bool.isRequired,
  hasAdTitleAddon: PropTypes.bool.isRequired,
  hasSeperateRangeAddon: PropTypes.bool.isRequired,
  hasPriceFromAddon: PropTypes.bool.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  activeTab: PropTypes.string.isRequired,
  photos: PropTypes.array.isRequired,
  setError: PropTypes.func.isRequired,
  setSmsWasSent: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired
}

export default connect(mapStateToProps, { createAd, setError, setSmsWasSent })(AddAdForm)
